import type { Address } from "./foodModel"

export enum FoodStoreType {
  '' = '',
  Restaurant = 'Restaurant',
  Grocery = 'Grocery',
}

export enum FoodSort {
  Rating = 'Rating',
  Cheapest = 'Cheapest',
  Fastest = 'Fastest',
  Distance = 'Distance',
  Relevance = 'Relevance',
}

export enum FoodSearchFocus {
  '' = '',
  Item = 'Item',
  Store = 'Store',
}

export interface DeliveryInfo{
  deliveryType: 'delivery' | 'pickup'
  userAddress: Address
}

export interface SelectedStoreInformation{
    store_info:SelectedStoreProps
}

export interface SelectedStoreProps{
    store_id: string,
    store_description:string,
    store_rating: number,
    store_rating_count: number,
    store_address: Address,
    store_cuisine: string[],
    store_name: string,
    store_delivery_time: number,
    store_delivery_distance: number,
    store_image: string[],
    pickup_enabled: boolean,
    delivery_enabled: boolean,
}